'use client'
import { MotionConfig } from 'framer-motion'
import { LanguageProvider } from '@/lib/context/LanguageContext'
import { AlternateLinksProvider } from '@/lib/context/AlternateLinksContext'
import type { Lang } from '@/lib/i18n'

export default function Providers({
  children,
  initialLang,
}: {
  children: React.ReactNode
  initialLang?: Lang
}) {
  // reducedMotion="user" makes every Framer Motion component honor the OS
  // "Reduce motion" setting — transform/layout animations are dropped (no
  // vestibular-triggering movement) while opacity fades are kept. Covers all of
  // FadeInUp/BlurIn/Slide/Zoom/Stagger at once. (CSS keyframe animations —
  // marquee/twinkle — are handled separately in globals.css.)
  return (
    <MotionConfig reducedMotion="user">
      <LanguageProvider initialLang={initialLang}>
        <AlternateLinksProvider>{children}</AlternateLinksProvider>
      </LanguageProvider>
    </MotionConfig>
  )
}
